module.exports = __webpack_public_path__ + "media/images/story/top/q-7c26adeb413ab13a19c502ada10b4f26.svg";